/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';

import { bool, string } from 'prop-types';
import classNames from 'clsx';

import KstingLogo from 'gfx/vector/ksting-logo-light.svg';
import KstingLogoDark from 'gfx/vector/ksting-logo.svg';

import styles from './site-logo.scss';

/**
 * This is the SiteLogo component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 * @author Niklas Rosdahl <niklas.rosdahl@vntrs.com>
 */

export default class SiteLogo extends Component {
  shouldComponentUpdate() {
    return false;
  }

  static propTypes = {
    light: bool,
    dark: bool,
    left: bool,
    right: bool,
    className: string,
  };

  static defaultProps = {
    light: false,
    dark: false,
    left: false,
    right: false,
    className: null,
  };

  /**
   * Render SiteLogo.
   *
   * @return {Object}
   */
  render() {
    const { light, dark, left, right, className } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, className, {
          [styles.left]: left,
          [styles.right]: right,
        })}
      >
        {light && <KstingLogo className={styles.logo} />}
        {dark && <KstingLogoDark className={styles.logo} />}
      </div>
    );
  }
}
